/* App-only purchase entry. Email capture is not an invitation or install receipt. */
(() => {
  if (window.ModernMailSignup) return;
  const dialog = document.getElementById('MMTestFlight');
  if (!dialog) return;
  const form = dialog.querySelector('form');
  const email = form.querySelector('[type=email]');
  const fields = form.querySelector('[data-mm-signup-fields]');
  const submit = form.querySelector('[type=submit]');
  const status = form.querySelector('[role=status]');
  let trigger;
  let pending = false;
  let completed = false;

  function open(opener) {
    trigger = opener || document.activeElement;
    if (!dialog.open) dialog.showModal();
    (completed ? status : email).focus();
  }
  window.ModernMailSignup = { open };
  dialog.querySelector('[data-mm-signup-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('keydown', (event) => {
    // Keep focus here until keyup, so Escape cannot also dismiss a parent Dawn modal.
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('button, input, a[href]')]
      .filter(control => !control.disabled && control.getClientRects().length > 0 && control.type !== 'hidden');
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (!controls.includes(document.activeElement)) {
      event.preventDefault(); (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  });
  dialog.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    event.stopPropagation();
    dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (!pending) email.value = '';
    if (trigger?.isConnected) trigger.focus();
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mm-signup]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();
    open(button);
  });
  // Defense in depth for existing Dawn product forms injected by variant/quick-add refresh.
  document.addEventListener('submit', (event) => {
    if (!event.target.matches('[data-type="add-to-cart-form"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(event.submitter);
  }, true);

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (pending || completed) return;
    email.value = email.value.trim();
    if (!email.checkValidity()) {
      email.setAttribute('aria-invalid', 'true');
      status.textContent = 'Enter a valid email address.';
      email.focus();
      return;
    }
    email.removeAttribute('aria-invalid');
    pending = true;
    submit.disabled = true;
    form.setAttribute('aria-busy', 'true');
    status.textContent = 'Signing up…';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const action = new URL(form.action, location.href);
      if (action.origin !== location.origin) throw new Error('Untrusted capture target');
      const response = await fetch(action.href, {
        method: 'POST', body: new URLSearchParams(new FormData(form)),
        credentials: 'same-origin', signal: controller.signal,
      });
      if (!response.ok || new URL(response.url || action.href).origin !== location.origin) throw new Error('Unconfirmed capture');
      const result = new DOMParser().parseFromString(await response.text(), 'text/html')
        .querySelector('#MMTestFlightForm');
      if (!result?.querySelector('[data-mm-signup-result="success"]') || result.querySelector('[data-mm-signup-result="error"]')) {
        throw new Error('Unconfirmed capture');
      }
      completed = true;
      fields.hidden = true;
      email.value = '';
      status.textContent = 'Thanks for signing up. We’ll email you about TestFlight access.';
      if (dialog.open) status.focus();
    } catch {
      status.textContent = 'We couldn’t confirm your signup. Please try again, or contact us if this continues.';
    } finally {
      clearTimeout(timeout);
      pending = false;
      submit.disabled = false;
      form.removeAttribute('aria-busy');
      if (!dialog.open) email.value = '';
    }
  });
})();
